<template>
    <app-layout title="Kontaktní formulář">
        <div class="min-h-full py-6 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-6">
            <div class="relative max-w-xl mx-auto bg-white p-8 rounded-lg shadow-md">
                <svg class="absolute left-full transform translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                    <defs>
                        <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                </svg>
                <svg class="absolute right-full bottom-0 transform -translate-x-1/2" width="404" height="404" fill="none" viewBox="0 0 404 404" aria-hidden="true">
                    <defs>
                        <pattern id="85737c0e-0916-41d7-917f-596dc7edfa27" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                            <rect x="0" y="0" width="4" height="4" class="text-gray-200" fill="currentColor" />
                        </pattern>
                    </defs>
                    <rect width="404" height="404" fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
                </svg>
                <div class="text-center">
                    <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        Kontaktujte nás
                    </h2>
                    <p class="mt-4 text-lg leading-6 text-gray-500">
                        Potřebujete s něčím poradit? Napište nám zprávu pomocí tohoto formuláře
                        nebo si přečtěte odpovědi na <a target="_blank" class="underline" :href="route('faq')">často kladené otázky</a>.
                    </p>
                </div>
                <div class="mt-12">
                    <form @submit.prevent="send" action="#" method="POST" class="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                        <div class="sm:col-span-2">
                            <jet-label required for="email">Email</jet-label>
                            <div class="mt-1">
                                <jet-input required v-model="form.email"  id="email" name="email" type="email" autocomplete="email" class="w-full"></jet-input>
                            </div>
                        </div>
                        <div class="sm:col-span-2">
                            <jet-label for="phone">Telefon <i>(přejete-li si kontaktovat telefonicky)</i></jet-label>
                            <div class="mt-1">
                                <jet-input v-model="form.phone" id="phone" name="phone" type="text" autocomplete="tel" class="w-full"></jet-input>
                            </div>
                        </div>
                        <div class="sm:col-span-2">
                            <jet-label required for="subject">Předmět</jet-label>
                            <div class="mt-1">
                                <jet-input required v-model="form.subject" class="w-full" type="text" name="subject" id="subject"></jet-input>
                            </div>
                        </div>
                        <div class="sm:col-span-2">
                            <jet-label required for="text">Zpráva nebo popis problému</jet-label>
                            <div class="mt-1">
                                <textarea required v-model="form.text" id="text" name="text" rows="4" class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"></textarea>
                            </div>
                        </div>
                        <div class="sm:col-span-2">
                            <button type="submit" class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Odelsat
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </app-layout>

</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import { Link } from '@inertiajs/inertia-vue3'
export default {
    name: "Help",
    components: {
        AppLayout,
        InertiaLink: Link,
        JetInput,
        JetLabel
    },

    data() {
        return {
            form: this.$inertia.form({
                email: this.$page.props.email,
                phone: null,
                subject: null,
                text: null
            })
        }
    },
    methods: {
        send(){
            this.form.post(route('help.post'), {
                preserveState: false
            });
        },

    }
}
</script>

<style scoped>

</style>
